import { useEffect, useState } from "react";
import { Button, Col, Flex, Row, Table } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/pro-regular-svg-icons";

import { GET } from "../../../providers/useAxiosQuery";
import {
	TableGlobalSearchAnimated,
	TablePageSize,
	TablePagination,
	TableShowingEntriesV2,
} from "../../../providers/CustomTableFilter";
import ModalFormStudentSchedule from "./components/ModalFormStudentSchedule";
import FloatSelect from "../../../providers/FloatSelect";

export default function PageStudentSchedule() {
	const [tableFilter, setTableFilter] = useState({
		page: 1,
		page_size: 50,
		search: "",
		sort_field: "created_at",
		sort_order: "desc",
		isTrash: 0,
		from: "evaluation",
		student_id: "",
		subject_id: "",
		section_id: "",
		semester_id: "",
		school_year_id: "",
		course_id: "",
	});

	const [toggleModalStudentSchedule, setToggleModalStudentSchedule] = useState({
		open: false,
		data: null,
	});

	const { data: dataProfile } = GET(
		`api/profile?sort_field=fullname&sort_order=asc&roleTypes=Student`,
		"student_schedule_dropdown",
		() => {},
		false,
	);

	const { data: dataSubject } = GET(
		`api/subject?sort_field=code&sort_order=asc`,
		"subject_dropdown",
		() => {},
		false,
	);

	const { data: dataSection } = GET(
		`api/section_dropdown?sort_field=section&sort_order=asc`,
		"section_dropdown_dropdown",
		() => {},
		false,
	);

	const { data: dataSemester } = GET(
		`api/semester?sort_field=semester&sort_order=asc`,
		"semester_dropdown",
		() => {},
		false,
	);

	const { data: dataSchoolYear } = GET(
		`api/school_year?sort_field=school_year&sort_order=asc`,
		"school_year_dropdown",
		() => {},
		false,
	);

	const { data: dataCourse } = GET(
		`api/course_list?sort_field=course_name&sort_order=asc`,
		"course_dropdown",
		() => {},
		false,
	);

	const { data: dataSource, refetch: refetchSource } = GET(
		`api/student_schedules?${new URLSearchParams(tableFilter)}`,
		"student_schedule_list",
	);

	useEffect(() => {
		refetchSource();

		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [tableFilter]);

	const onChangeTable = (pagination, filters, sorter) => {
		setTableFilter((ps) => ({
			...ps,
			sort_field: sorter.columnKey,
			sort_order: sorter.order ? sorter.order.replace("end", "") : null,
			page: 1,
		}));
	};

	return (
		<Row gutter={[20, 20]} id="tbl_wrapper">
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="Student"
					placeholder="Student"
					options={
						dataProfile
							? dataProfile.data.map((item) => ({
									value: item.id,
									label: `${item.school_id} - ${item.fullname}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.student_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							student_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="Subject"
					placeholder="Subject"
					options={
						dataSubject
							? dataSubject.data.map((item) => ({
									value: item.id,
									label: `${item.code} - ${item.description}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.subject_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							subject_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="Section"
					placeholder="Section"
					options={
						dataSection
							? dataSection.data.map((item) => ({
									value: item.id,
									label: `${item.section}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.section_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							section_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="Semester"
					placeholder="Semester"
					options={
						dataSemester
							? dataSemester.data.map((item) => ({
									value: item.id,
									label: `${item.semester}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.semester_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							semester_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="School Year"
					placeholder="School Year"
					options={
						dataSchoolYear
							? dataSchoolYear.data.map((item) => ({
									value: item.id,
									label: `${item.school_year}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.school_year_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							school_year_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={12} md={6} lg={6} xl={4}>
				<FloatSelect
					label="Course"
					placeholder="Course"
					options={
						dataCourse
							? dataCourse.data.map((item) => ({
									value: item.id,
									label: `${item.course_name}`,
								}))
							: []
					}
					allowClear
					value={tableFilter.course_id || null}
					onChange={(value) => {
						setTableFilter((ps) => ({
							...ps,
							course_id: value || "",
						}));
					}}
				/>
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-top-filter">
					<Flex gap={10}>
						<Button
							type={tableFilter.isTrash === 0 ? "primary" : "default"}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 0,
								}));
							}}
						>
							Active
						</Button>
						<Button
							type={tableFilter.isTrash === 1 ? "primary" : "default"}
							onClick={() => {
								setTableFilter((ps) => ({
									...ps,
									isTrash: 1,
								}));
							}}
						>
							Archived
						</Button>
					</Flex>

					<TablePageSize
						tableFilter={tableFilter}
						setTableFilter={setTableFilter}
					/>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-top-filter">
					<Flex gap={10}>
						<TableGlobalSearchAnimated
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
						/>
					</Flex>

					<Flex gap={15} align="center">
						<TableShowingEntriesV2 />

						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Table
					dataSource={dataSource ? dataSource?.data.data : []}
					rowKey={(rowKey) => rowKey.id}
					pagination={false}
					bordered={false}
					scroll={{ x: "max-content" }}
					sticky={true}
					onChange={onChangeTable}
				>
					<Table.Column
						title="Action"
						key="action"
						width={150}
						align="center"
						render={(_, record) => {
							return (
								<Flex gap={5} align="center" justify="center">
									<Button
										type="link"
										className="w-auto h-auto"
										icon={<FontAwesomeIcon icon={faEdit} />}
										onClick={() => {
											setToggleModalStudentSchedule({
												open: true,
												data: record,
											});
										}}
									/>
								</Flex>
							);
						}}
					/>
					<Table.Column
						title="Created At"
						key="created_at"
						dataIndex="created_at_format"
						width={150}
						sorter
					/>
					<Table.Column
						title="School ID"
						key="school_id"
						dataIndex="school_id"
						width={120}
						sorter
					/>
					<Table.Column
						title="Name"
						key="fullname"
						dataIndex="fullname"
						width={120}
						sorter
					/>
					<Table.Column
						title="Subject Code"
						key="subject_code"
						dataIndex="subject_code"
						width={150}
						sorter
					/>
					<Table.Column
						title="Subject Section"
						key="section"
						dataIndex="section"
						width={150}
						sorter
					/>
					<Table.Column
						title="Description"
						key="subject_description"
						dataIndex="subject_description"
						width={150}
						sorter
					/>
					<Table.Column
						title="Credited Units"
						key="credit_unit"
						dataIndex="credit_unit"
						width={150}
						sorter
					/>
				</Table>
			</Col>

			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<Flex justify="space-between" className="tbl-bottom-filter">
					<div />
					<Flex gap={15} align="center">
						<TableShowingEntriesV2 />
						<TablePagination
							tableFilter={tableFilter}
							setTableFilter={setTableFilter}
							total={dataSource?.data.total}
							showLessItems={true}
							showSizeChanger={false}
							tblIdWrapper="tbl_wrapper"
						/>
					</Flex>
				</Flex>
			</Col>

			<ModalFormStudentSchedule
				toggleModalStudentSchedule={toggleModalStudentSchedule}
				setToggleModalStudentSchedule={setToggleModalStudentSchedule}
				dataProfile={dataProfile}
				dataSubject={dataSubject}
				dataSection={dataSection}
				dataSemester={dataSemester}
				dataSchoolYear={dataSchoolYear}
				dataCourse={dataCourse}
			/>
		</Row>
	);
}
